import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DataService } from '../../../service/data.service';
import { LayoutService } from '../../../service/layout.service';
import { Company } from '../../../interface/company';
import { MigrateCommonService } from 'src/app/service/migrate-common.service';
import { MkgOS } from 'src/app/class/mkg-os';
import { INVOICE_STATE } from 'src/app/shared/lists/invoice-state';
import { MigrateService, SEFAZ_CODES } from 'src/app/service/migrate.service';
import { BoletoService } from 'src/app/service/boleto.service';
import { NF_response } from 'src/app/interface/NF-response';
import { Client } from 'src/app/interface/client';
import { Supplier } from 'src/app/interface/supplier';
import { Boleto } from 'src/app/interface/boleto-pjbank';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { DataCacheService } from 'src/app/service/data-cache.service';
import { CashTitle } from 'src/app/interface/cash-title';
import { LocalStorageService } from '@app/service/local.storage.service';

export interface AskRedirectComponentDataType {
  model: 'NFCe' | 'NFe';
  linkNf?: string;
  linkNFSe?: string;
  nfeHasError: any;
  nfseHasError: any;
  backTo: string,
  codeSystem?: number,
  invoiceState?: number,
  companyLabors?: Company,
  companyParts?: Company,
  osAsk?: MkgOS,
  boletoTitles?: string[],
  invoice?: NF_response,
  client?: Client | Supplier,
  title?: CashTitle[]
}

@Component({
  selector: 'app-ask-redirect',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,

    MatDialogTitle,
    MatDialogContent,
    MatButtonModule,
    MatIcon,
    MatDialogClose,
    MatProgressSpinner,
    MatDialogActions,

  ],
  templateUrl: './ask-redirect.component.html',
  styleUrls: ['./ask-redirect.component.scss']
})
export class AskRedirectComponent implements OnInit {
  nfError;
  nfseError;
  os: MkgOS | undefined;
  createdBoleto = signal<Boleto | null>(null);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AskRedirectComponentDataType,
    public dataService: DataService,
    public layout: LayoutService,
    private boletoService: BoletoService,
    private _migrateService: MigrateService,
    private router: Router,
    private _localStorageService: LocalStorageService,
    private dialogRef: MatDialogRef<AskRedirectComponent>,
  ) { }

  ngOnInit() {
    if (this.data.osAsk) {
      this.os = this.data.osAsk;
    }
    this.getErrors()
  }

  canCreateBoleto() {
    return this.data.boletoTitles.length > 0 && !this.createdBoleto() && this.data.osAsk.client && this.data.osAsk.client.document !== environment.DEFAULT_CLIENT_DOCUMENT
  }

  isOIM(state): string {
    let isOIM: string = '';
    if (state == INVOICE_STATE.INPUT_WITHOUT_XML) {
      isOIM = 'OIM'
    } else {
      isOIM = 'OIP'
    }
    return isOIM;
  }

  private async getErrors() {
    if (this.data.linkNf) {
      const nf = await this._migrateService.getNFById(this.data.linkNf, this.data.companyParts.cnpj);
      if (!nf) {
        this.nfError = "not_found";
      } else {
        const rejection = this.data?.nfeHasError ?? MigrateCommonService.getRejectionsNF(nf);
        if (!rejection || (rejection?.migrateCode && rejection?.sefazCode && rejection?.migrateCode === 100 && rejection?.sefazCode === SEFAZ_CODES.AUTORIZADO)) {
          this.nfError = null
        } else {
          this.nfError = rejection
        }
      }
    }

    if (this.data.linkNFSe) {
      const nfse = await this._migrateService.getNFSEById(this.data.linkNFSe, this.data.companyLabors.cnpj);
      if (!nfse) {
        this.nfseError = "not_found";
      } else {
        const rejection = this.data?.nfseHasError ?? MigrateCommonService.getRejectionsNFS(nfse);
        if (!rejection || (rejection.migrateCode && rejection.sefazCode && rejection.migrateCode === 100 && rejection.sefazCode === SEFAZ_CODES.AUTORIZADO)) {
          this.nfseError = null
        } else {
          this.nfseError = rejection
        }
      }
    }
  }

  createBoleto(): void {
    const invoice = this.data.invoice;
    const titles = this.data.boletoTitles;
    const os = this.data.osAsk;
    const client = this.data.client;

    if (os) {
      this.boletoService.createBoletoFromOs({ osId: os.id, titles: titles }).then((boletos) => {
        this.createdBoleto.set(boletos[0]);
      }).catch(() => {
        this.createdBoleto.set(null);
      })
    } else {
      this.boletoService.createBoletoFromInvoice({ invoice: invoice, titles: titles, client }).then((boletos) => {
        this.createdBoleto.set(boletos[0]);
      }).catch(() => {
        this.createdBoleto.set(null);
      })
    }
  }

  goToTitles(){
    this._localStorageService.saveDataJSON('cash-title-cache', {
      filter: { companyCode: this.os.codeSystem }
    });
  
    this.goTo(['financial', 'cash-title']);
  }

  goTo(to: string[]){
    this.dialogRef.close({ redirected: true, to: to?.[0] || "" });

    this.router.navigate(['/company', this.data.companyLabors.id, ...to]);
  }
}
